// extracted by mini-css-extract-plugin
export default {"panel":"panel--ouLTm","receipt":"receipt--EGViq","receipt-root":"receipt-root--A7XoT","receipt-wrapper":"receipt-wrapper--O8_n3","left":"left--fcl_7"};